import React from 'react';

function StepperButton({ children, onClick, disabled }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed"
    >
      {children}
    </button>
  );
}

export default function SeatStepper({ icon, label, description, value, onChange, min = 0, max = 999 }) {
  const inc = () => onChange(Math.min(max, value + 1));
  const dec = () => onChange(Math.max(min, value - 1));

  return (
    <div className="flex items-center justify-between rounded-lg border border-gray-200 p-4">
      <div className="flex items-start gap-3 min-w-0 flex-1">
        {icon && <div className="shrink-0 mt-0.5">{icon}</div>}
        <div className="min-w-0">
          <p className="font-medium text-gray-900 text-sm">{label}</p>
          {description && <p className="text-xs text-gray-500">{description}</p>}
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0 ml-3">
        <StepperButton onClick={dec} disabled={value <= min}>−</StepperButton>
        <span className="w-8 text-center font-semibold text-gray-900">{value}</span>
        <StepperButton onClick={inc} disabled={value >= max}>+</StepperButton>
      </div>
    </div>
  );
}
